import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";

import Header from "@/components/Header";
import Home from "@/pages/Home";
import Category from "@/pages/Category";
import ProductDetail from "@/pages/ProductDetail";
import AdminPortal from "@/pages/AdminPortal";

function ShellRoutes() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Header />}
      <main style={{ paddingTop: isAdmin ? 0 : 64 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sunglasses" element={<Category category="Sunglasses" />} />
          <Route path="/eyeglasses" element={<Category category="Eyeglasses" />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/admin" element={<AdminPortal />} />
        </Routes>
      </main>
      {!isAdmin && (
        <footer className="container-vzor" style={{ padding: "48px 24px", color: "#6B7280", fontSize: 14 }}>
          <div style={{ borderTop: "1px solid #E5E7EB", paddingTop: 24 }}>
            © {new Date().getFullYear()} VZOR — See better. Look sharper.
          </div>
        </footer>
      )}
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <ShellRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;
